
export enum ToggleableFields {
  Text1 = 0,
  Text2,
  Comment
}

export class Survey {

  public static MAX_COMMENT_LENGTH = 300;

  date: string;
  development: string;
  text: string;
  seq: number;
  score: number;
  stars: number;
  comment: string;
  label1: string;
  label2: string;
  text1: string;
  text2: string;

  text1CanToggle = false;
  text2CanToggle = false;
  commentCanToggle = false;

  text1Expanded = false;
  text2Expanded = false;
  commentExpanded = false;

  constructor(public data: any) {
    const json: JSON = data;

    this.date = json['date'];
    this.development = json['development'];
    this.text = json['qtext'];
    this.score = json['qscore'];
    this.seq = json['seq'];
    this.stars = json['stars'];
    this.comment = json['public_comment'];
    this.label1 = json['qtext1'];
    this.label2 = json['qtext2'];
    this.text1 = json['text1'];
    this.text2 = json['text2'];
    this.text1CanToggle = (this.text1 != null && this.text1.length > Survey.MAX_COMMENT_LENGTH);
    this.text2CanToggle = (this.text2 != null && this.text2.length > Survey.MAX_COMMENT_LENGTH);
    this.commentCanToggle = (this.comment != null && this.comment.length > Survey.MAX_COMMENT_LENGTH);
  }

  textForField(field: ToggleableFields) {

    switch (field) {
      case ToggleableFields.Text1: {

        if (this.text1.length < Survey.MAX_COMMENT_LENGTH || this.text1Expanded === true) {
          return this.text1;
        }
        return this.text1.substring(0, Survey.MAX_COMMENT_LENGTH) + ' ...';
      }

      case ToggleableFields.Text2: {

        if (this.text2.length < Survey.MAX_COMMENT_LENGTH  || this.text2Expanded === true) {
          return this.text2;
        }
        return this.text2.substring(0, Survey.MAX_COMMENT_LENGTH) + ' ...';
      }

      case ToggleableFields.Comment: {

        if (this.comment.length < Survey.MAX_COMMENT_LENGTH  || this.commentExpanded === true) {
          return this.comment;
        }
        return this.comment.substring(0, Survey.MAX_COMMENT_LENGTH) + ' ...';

      }
    }
  }

  toggleText(field: ToggleableFields) {
    switch (field) {
      case ToggleableFields.Text1: {
        this.text1Expanded = !this.text1Expanded;
        break;
      }

      case ToggleableFields.Text2: {
        this.text2Expanded = !this.text2Expanded;
        break;
      }

      case ToggleableFields.Comment: {
        this.commentExpanded = !this.commentExpanded;
        break;
      }
    }
  }
}

/*

 {
 "date": "January 2014",
 "development": "Eastonbury",
 "qscore": 5.9,
 "qtext": "Overall Rating",
 "seq": 27,
 "stars": 6.0,
 "public_comment": "Thank you for your feedback."
 },

 */



// WEBPACK FOOTER //
// ./src/app/model/survey.ts